@if (!!item) {
  <svg  height="100%" width="100%" viewBox="25 0 210 256" xmlns="http://www.w3.org/2000/svg">
    <path d="m142.379 4h-28.758a4.811 4.811 0 0 0 -4.812 4.812 4.811 4.811 0 0 0 4.812 4.812h28.758a4.811 4.811 0 0 0 4.812-4.812 4.811 4.811 0 0 0 -4.812-4.812z" fill="#fcc24c"/>
    <path d="m117.942 13.624h20.117v60.273h-20.117z" fill="#526faa"/>
    <path d="m142.379 4h-7a4.812 4.812 0 1 1 0 9.624h7a4.812 4.812 0 1 0 0-9.624z" fill="#dea42e"/>
    <path d="m113.621 13.624h7a4.812 4.812 0 1 1 0-9.624h-7a4.812 4.812 0 1 0 0 9.624z" fill="#fce06a"/>
    <path d="m138.059 75.9h-20.118a2 2 0 0 1 -2-2v-60.276a2 2 0 0 1 2-2h20.118a2 2 0 0 1 2 2v60.276a2 2 0 0 1 -2 2zm-18.118-4h16.118v-56.276h-16.118z" fill="#690589"/>
    <path d="m142.379 15.624h-28.758a6.812 6.812 0 1 1 0-13.624h28.758a6.812 6.812 0 1 1 0 13.624zm-28.758-9.624a2.812 2.812 0 1 0 0 5.624h28.758a2.812 2.812 0 1 0 0-5.624z" fill="#690f00589"/>
    <g>
      <path d="M 52.547 37.329 L 52.547 233.466 C 52.547 243.702 60.844 252 71.08 252 L 184.92 252 C 195.156 252 203.453 243.702 203.453 233.466 L 203.453 37.329 L 52.547 37.329 Z" id="beer-content" style="fill: rgb(214, 214, 214);"></path>
      <rect [attr.y]="y" [attr.height]="height" x="65" width="125" [attr.fill]="item.beverage?.color" id="fill"></rect>
      <circle class="bubble" [attr.id]="'bubble1-'+item.id" r="2" cx="80" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble2-'+item.id" r="2" cx="100" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble3-'+item.id" r="4" cx="110" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble4-'+item.id" r="1" cx="130" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble5-'+item.id" r="3" cx="150" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble6-'+item.id" r="3" cx="170" cy="245"></circle>
      <circle class="bubble" [attr.id]="'bubble7-'+item.id" r="4" cx="180" cy="245"></circle>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble1-'+item.id" attributeName="cy" from="245" dur="15s" begin=".9s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble2-'+item.id" attributeName="cy" from="245" dur="9s" begin="1s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble3-'+item.id" attributeName="cy" from="245" dur="12s" begin="4s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble4-'+item.id" attributeName="cy" from="245" dur="8s" begin="2s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble5-'+item.id" attributeName="cy" from="245" dur="10s" begin=".9s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble6-'+item.id" attributeName="cy" from="245" dur="13s" begin="3s" repeatCount="indefinite" fill="freeze"></animate>
      <animate [attr.to]="bubbleEnd" [attr.xlink:href]="'#bubble7-'+item.id" attributeName="cy" from="245" dur="6s" begin="4s" repeatCount="indefinite" fill="freeze"></animate>
      <!--
      <svg width="135" height="211" x="195" y="0" viewBox="0 0 135 211" xmlns="http://www.w3.org/2000/svg" style="overflow:visible">
        <rect width="100%"
          [style.height.%]="item.amount*100/item.size" [attr.fill]="item.beverage?.color" class="fillup" transform="translate(0, 250) rotate(180) scale(1,1)" />
        <circle class="bubble" [attr.id]="'bubble7-'+item.id" r="2" cx="-10" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble7-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="15s"
          begin=".9s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble6-'+item.id" r="2" cx="-35" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble6-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="9s"
          begin=".2s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble5-'+item.id" r="4" cx="-50" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble5-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="12s"
          begin=".8s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble4-'+item.id" r="1" cx="-55" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble4-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="5s"
          begin=".5s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble3-'+item.id" r="2" cx="-70" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble3-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="10s"
          begin="1s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble2-'+item.id" r="3" cx="-90" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble2-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="8s"
          begin=".1s"
          repeatCount="indefinite"
          fill="freeze"/>
        <circle class="bubble" [attr.id]="'bubble1-'+item.id" r="3" cx="-110" cy="240"></circle>
        <animate
          [attr.xlink:href]="'#bubble1-'+item.id"
          attributeName="cy"
          from="240"
          [attr.to]="240-(item.amount*100/item.size)-item.amount*100/item.size+4"
          dur="15s"
          begin="1.5s"
          repeatCount="indefinite"
          fill="freeze"/>
      </svg> -->
      <path style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0);" d="M 111.199 49.233 L 107.959 55.004 L 113.528 62.395 L 141.168 62.192 L 147.851 56.016 L 144.914 48.726 L 111.199 49.233 Z"></path>
      <path d="m193.453 37.329v196.137a18.534 18.534 0 0 1 -18.533 18.534h10a18.534 18.534 0 0 0 18.533-18.534v-196.137z" fill="#d6d1cf" style="fill-opacity: .8;" id="beer-content-right"/>
      <path d="m62.547 37.329v196.137a18.534 18.534 0 0 0 18.533 18.534h-10a18.534 18.534 0 0 1 -18.533-18.534v-196.137z" fill="#fff" style="fill-opacity: .8;" id="beer-content-left"/>
    </g>
    <path d="m184.92 254h-113.84a20.556 20.556 0 0 1 -20.533-20.534v-196.136a2 2 0 0 1 2-2h150.906a2 2 0 0 1 2 2v196.136a20.556 20.556 0 0 1 -20.533 20.534zm-130.373-214.67v194.136a16.552 16.552 0 0 0 16.533 16.534h113.84a16.552 16.552 0 0 0 16.533-16.534v-194.136zm86.216 24.449h-25.526a9.011 9.011 0 0 1 0-18.021h25.526a9.011 9.011 0 0 1 0 18.021zm-25.526-14.021a5.011 5.011 0 0 0 0 10.021h25.526a5.011 5.011 0 0 0 0-10.021z" fill="#690589"/>
    <rect fill="#f4efed" height="17.639" rx="8.819" width="176.868" x="39.566" y="139.525"/>
    <path d="m207.615 222.792h-159.23a8.819 8.819 0 0 1 -8.819-8.819 8.819 8.819 0 0 1 8.819-8.82h159.23a8.819 8.819 0 0 1 8.819 8.82 8.819 8.819 0 0 1 -8.819 8.819z" fill="#f4efed"/>
    <path d="m207.615 91.536h-159.23a8.819 8.819 0 0 1 -8.819-8.819 8.819 8.819 0 0 1 8.819-8.82h159.23a8.819 8.819 0 0 1 8.819 8.82 8.819 8.819 0 0 1 -8.819 8.819z" fill="#f4efed"/>
    <path d="m207.615 73.9h-10a8.82 8.82 0 0 1 0 17.639h10a8.82 8.82 0 0 0 0-17.639z" fill="#d6d1cf"/>
    <path d="m48.385 91.536h10a8.82 8.82 0 0 1 0-17.639h-10a8.82 8.82 0 0 0 0 17.639z" fill="#fff"/>
    <path d="m207.615 139.525h-10a8.82 8.82 0 0 1 0 17.639h10a8.82 8.82 0 0 0 0-17.639z" fill="#d6d1cf"/>
    <path d="m48.385 157.164h10a8.82 8.82 0 0 1 0-17.639h-10a8.82 8.82 0 0 0 0 17.639z" fill="#fff"/>
    <path d="m207.615 205.153h-10a8.82 8.82 0 0 1 0 17.639h10a8.82 8.82 0 0 0 0-17.639z" fill="#d6d1cf"/>
    <path d="m48.385 222.792h10a8.82 8.82 0 0 1 0-17.639h-10a8.82 8.82 0 0 0 0 17.639z" fill="#fff"/>
    <g fill="#690589">
      <path d="m207.615 93.536h-159.23a10.819 10.819 0 1 1 0-21.638h159.23a10.819 10.819 0 1 1 0 21.638zm-159.23-17.636a6.819 6.819 0 1 0 0 13.638h159.23a6.819 6.819 0 1 0 0-13.638z"/>
      <path d="m207.615 159.164h-159.23a10.82 10.82 0 1 1 0-21.639h159.23a10.82 10.82 0 1 1 0 21.639zm-159.23-17.639a6.82 6.82 0 1 0 0 13.639h159.23a6.82 6.82 0 1 0 0-13.639z"/>
      <path d="m207.615 224.792h-159.23a10.82 10.82 0 1 1 0-21.639h159.23a10.82 10.82 0 1 1 0 21.639zm-159.23-17.639a6.82 6.82 0 1 0 0 13.639h159.23a6.82 6.82 0 1 0 0-13.639z"/>
    </g>
  </svg>
}